@if (isActivated) {
    <adapt-theme-test-container label="Components">
        <div class="section">
            <h2>Outcomes</h2>
            <div class="d-flex flex-wrap">
                @for (enum of OrganisationCategoryValue | keyvalue; track enum) {
                    <adapt-display-workflow-category class="p-2"
                                                     [category]="enum.value"></adapt-display-workflow-category>
                }
            </div>
            <h2>Pathways</h2>
            <div class="pathways">
                <h3>Onboarding</h3>
                <h4>Not started</h4>
                @if (workflowWelcomeOnboarding) {
                    <adapt-display-workflow-card [workflow]="workflowWelcomeOnboarding"></adapt-display-workflow-card>
                }
                <h3>Understand Journey</h3>
                <h4>Survey in progress</h4>
                @if (understandJourneySurveyInProgress) {
                    <adapt-display-workflow-card [connection]="understandJourneySurveyInProgress"></adapt-display-workflow-card>
                }
                <h4>Survey in progress (current user outstanding response)</h4>
                @if (understandJourneySurveyInProgressCurrentUserOutstanding) {
                    <adapt-display-workflow-card
                                                 [connection]="understandJourneySurveyInProgressCurrentUserOutstanding"></adapt-display-workflow-card>
                }
                <h4>Survey complete</h4>
                @if (understandJourneySurveyComplete) {
                    <adapt-display-workflow-card [connection]="understandJourneySurveyComplete"></adapt-display-workflow-card>
                }
                <h4>Survey completed, meeting not scheduled</h4>
                @if (understandJourneySurveyCompleteMeetingNotScheduled) {
                    <adapt-display-workflow-card
                                                 [connection]="understandJourneySurveyCompleteMeetingNotScheduled"></adapt-display-workflow-card>
                }
                <h3>Others</h3>
                <h4>Up next</h4>
                @if (workflowUpNext) {
                    <adapt-display-workflow-card [workflow]="workflowUpNext"></adapt-display-workflow-card>
                }
                <h4>Started</h4>
                @if (workflowStarted) {
                    <adapt-display-workflow-card [connection]="workflowStarted"></adapt-display-workflow-card>
                }
                <h4>Meeting not scheduled</h4>
                @if (workflowMeetingNotScheduled) {
                    <adapt-display-workflow-card [connection]="workflowMeetingNotScheduled"></adapt-display-workflow-card>
                }
                <h4>Meeting scheduled</h4>
                @if (workflowMeetingScheduled) {
                    <adapt-display-workflow-card [connection]="workflowMeetingScheduled"></adapt-display-workflow-card>
                }
                <h4>Meeting running</h4>
                @if (workflowMeetingRunning) {
                    <adapt-display-workflow-card [connection]="workflowMeetingRunning"></adapt-display-workflow-card>
                }
                <h4>Prerequisites not satisfied</h4>
                @if (workflowLocked) {
                    <adapt-display-workflow-card [workflow]="workflowLocked"></adapt-display-workflow-card>
                }
                <h4>Planned</h4>
                @if (workflowComingSoon) {
                    <adapt-display-workflow-card [workflow]="workflowComingSoon"></adapt-display-workflow-card>
                }
            </div>
        </div>
        <div class="section">
            <h2>Dashboard element (HQ)</h2>
            <adapt-styled-dashboard-element name="Element title without link">Projected dashboard content goes
                here</adapt-styled-dashboard-element>
            <adapt-styled-dashboard-element name="Element title with a link"
                                            linkText="Link text"
                                            url="#">Projected dashboard content goes here </adapt-styled-dashboard-element>
        </div>
        <div class="section">
            <h2>Workflow Dialog</h2>
            <div>
                <button class="btn btn-primary"
                        (click)="showDialog()">Show 'Create a value' workflow dialog'</button>
            </div>
        </div>
        <div class="section">
            <h2>Tours</h2>
            <div>
                @for (tour of allTours; track tour) {
                    <button class="btn btn-primary me-3 mb-3"
                            (click)="runWrapUpTour(tour)">Show {{ tour }}</button>
                }
            </div>
        </div>
    </adapt-theme-test-container>
}
